import { useT } from "@transifex/react";

export const EmptyActivitiesContainer = () => {
    const t = useT();

    const t_noActivities = t("No current activities.", {
        _tags: "ClassMemberDashboard, EmptyActivities",
    });
    const t_waitForTeacher = t("Wait until your teacher shares a new activity with you :)", {
        _tags: "ClassMemberDashboard, EmptyActivities",
    });

    return (
        <div
            className="bg-white rounded-medium border border-p6-grey-light w-full flex flex-col items-center justify-center gap-xs p-m text-center"
            data-testid="classroom-activities-empty"
        >
            <p className="text-l text-p6-grey-mid">{t_noActivities}</p>
            <p className="text-l text-p6-grey-mid">{t_waitForTeacher}</p>
        </div>
    );
};
